import Vue from 'vue';
import Vuetify from 'vuetify';

Vue.use(Vuetify);

import OwlCarousel from 'v-owl-carousel'
Vue.component('carousel', OwlCarousel);

Vue.config.productionTip = false;
Vue.config.devtools = false;

Vue.component('HomeProjects', require('../components/index/HomeProjects').default);

if (document.getElementById("projects-home")) {
    new Vue({
        el: '#projects-home',
        components: {},
        props: {},
        data: () => ({

        }),
        vuetify: new Vuetify(),
    });
}